var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{attrs:{"id":"loader_wrapper"}},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"message"},[_vm._v("Loading now ...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }